<template>
  <div>
    <!-- 交易号修改 -->
    <el-dialog :title="$t('message.transactionNumberModification')" :close-on-click-modal="false"
      :visible.sync="$parent.updatePurchaseDialogVisible" width="488px" center>
      <div class="content">
        <!-- 修改后交易号： -->
        <div class="label">
          {{ $t("message.transactionNumberAfterModification") }}
          ：
        </div>
        <div class="val">
          <el-input v-model="purchase_no"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="$parent.updatePurchaseDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    ids: { type: Array },
  },
  data() {
    return {
      purchase_no: "",
    };
  },
  methods: {
    // 保存
    save() {
      if (this.purchase_no == "")
        return this.$message.error(
          this.$t("message.theNewTransactionNumberIsNotFilledIn")
        );
      let datas = {
        orderPurchaseIdSet: this.ids,
        purchase_no: this.purchase_no,
      };
      this.$api.orderApi.updatePurchase(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.updatePurchaseDialogVisible = false;
        this.$parent.orderDetails();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 3;
  }
}
</style>